import { render, staticRenderFns } from "./dealRadio.vue?vue&type=template&id=0cfddf1a&scoped=true&"
import script from "./dealRadio.vue?vue&type=script&lang=js&"
export * from "./dealRadio.vue?vue&type=script&lang=js&"
import style0 from "./dealRadio.vue?vue&type=style&index=0&id=0cfddf1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfddf1a",
  null
  
)

export default component.exports